import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  // CustomInput
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
} from 'reactstrap';
import moment from 'moment';
import validator from 'validator';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import CustomButton from '../../../../components/CustomButton';
import CustomCheckbox from '../../../../components/CustomCheckbox';
import { statusList } from 'views/admin/Activities';
import constants from 'config/constants';
// import { handleKeyNumberPress, handleKeyCharacterPress } from 'utils/commonFunc';
import { Box, Card } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchAdmissionService } from 'actions/admin/admissions';
import { store } from 'index';
import axios from 'axios';
import { formResMessage } from 'utils/commonFunc';

const relationTypes = [
  { label: 'Mother', value: 'MOTHER' },
  { label: 'Father', value: 'FATHER' },
  { label: 'Uncle', value: 'UNCLE' },
  { label: 'Friend', value: 'FRIEND' },
  // { label: 'Other', value: 'OTHER' }
];

const initialState = {
  data: {
    admissionId: 0,
    applicationNo: '', // Req
    schoolId: 0, // Req
    batchId: 0, // Req
    courseId: 0, // Req
    // Student
    firstName: '', // Req
    lastName: '', // Req
    acadYear: '',
    admissionYear: '',
    email: '',
    gender: '',
    dateOfBirth: '',
    birthPlace: '',
    bloodGroup: '',
    // category: '',
    // curriculumInterested: '',
    // hostelAccomodation: '',
    isPhysicallyChallenged: false,
    // mediumInstruction: '',
    motherTongue: '',
    nationality: '',
    // middleName: '',
    religion: '',
    // Guardian
    guardianName: '',
    guardianEmail: '', // Req
    phoneNumber: '', // Req
    education: '',
    income: 0,
    occupation: '',
    relation: '',
    // Additional
    remarks: '',
    staffCode: '',
    isStaffChild: false,
    status: 'PENDING',
  },
  errors: {},
  loading: false,
};

const UserAdmissionForm = props => {
  const {
    // isModalOpen,
    // schools,
    // saveAdmission,
    // updateAdmission,
    // admissionUpdateSuccess,
    // formModalCloseProp,
    // admission,
    loggedUserRole,
  } = props;
  const { admissionId, schoolId, phoneNumber } = useParams();
  const stateObj = initialState;
  const reduxStore = useSelector(state => state);
  const authStore = reduxStore.auth;
  const admissionStore = reduxStore.admissions;
  const admission = admissionStore.admission;

  const [stateVal, setState] = useState(stateObj);

  useEffect(() => {
    if (admission && Object.keys(admission).length) {
      setState(prevState => ({
        ...prevState,
        data: admission,
      }));
    } else {
      store.dispatch(
        fetchAdmissionService({
          admissionId,
          phoneNumber,
          schoolId,
          token: authStore.loggedUserToken,
        })
      );
    }
  }, [admission]);

  const handleChange = e => {
    e.persist();
    setState(prevState => ({
      ...prevState,
      data: { ...prevState.data, [e.target.name]: e.target.value },
    }));
  };

  const handleCheckChange = e => {
    e.persist();
    setState(prevState => ({
      ...prevState,
      data: { ...prevState.data, [e.target.name]: e.target.id },
    }));
  };

  const handleSelectChange = (name, selectItem) => {
    setState(prevState => ({
      ...prevState,
      data: {
        ...prevState.data,
        [name]: selectItem,
      },
    }));
  };

  const handleDateChange = (name, date) => {
    setState(prevState => ({
      ...prevState,
      data: { ...prevState.data, [name]: moment(moment(date).format('YYYY-MM-DD HH:mm:ss')).valueOf() },
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const { data } = stateVal;
    const errors = validate(data);
    setState(prevState => ({ ...prevState, errors }));
    if (!Object.keys(errors).length) {
      setState(prevState => ({ ...prevState, loading: true }));
      if (admissionId) {
        try {
          await axios.put(
            `${constants.API_BASE_URL}/api/update-admission-form/${admissionId}`,
            data,
            constants.setHeader(authStore.loggedUserToken)
          );
          alert('Thanks for your enquiry, We will review your application and reach out to you');
          setState(prevState => ({ ...prevState, loading: false }));
        } catch (err) {
          setError(err);
        }
      }
    }
  };

  const setError = err => {
    setState(prevState => ({
      ...prevState,
      errors: {
        global: formResMessage(err),
      },
      loading: false,
    }));
  };

  // const stateValReset = () => {
  //   setState(stateObj);
  // };

  // const formModalClose = () => {
  //   stateValReset();
  //   formModalCloseProp();
  // };

  const validate = data => {
    const errors = {};
    if (!data.applicationNo) {
      errors.applicationNo = 'Application number cannot be empty';
    }
    // if (!data.batchId) {
    //   errors.batchId = 'Batch cannot be empty';
    // }
    if (!data.courseId) {
      errors.courseId = 'Course cannot be empty';
    }
    if (!data.firstName) {
      errors.firstName = 'First name cannot be empty';
    }
    if (!data.lastName) {
      errors.lastName = 'Last name cannot be empty';
    }
    if (!data.guardianEmail) {
      errors.guardianEmail = 'Email cannot be empty';
    } else if (!validator.isEmail(data.guardianEmail)) {
      errors.guardianEmail = 'Invalid email';
    }
    if (!data.phoneNumber) {
      errors.phoneNumber = 'Phone number cannot be empty';
    }
    if (!data.status) {
      errors.status = 'Status cannot be empty';
    }
    if (!data.gender) {
      errors.gender = 'Gender cannot be empty';
    }
    if (!data.relation) {
      errors.relation = 'Relation cannot be empty';
    }
    // if (validator.isEmpty(data.gender)) {
    //   errors.gender = 'Gender cannot be empty';
    // }
    // if (validator.isEmpty(data.dateOfBirth.toString())) {
    //   errors.dateOfBirth = 'Date of birth cannot be empty';
    // } else if (moment(data.dateOfBirth) > moment().subtract(21, 'years')) {
    //   errors.dateOfBirth = 'Invalid date of birth, Minimum age should be 21';
    // }
    // if (validator.isEmpty(data.qualification)) {
    //   errors.qualification = 'Qualification cannot be empty';
    // }
    // if (validator.isEmpty(data.joiningDateTime.toString())) {
    //   errors.joiningDateTime = 'Joining date cannot be empty';
    // } else if (data.dateOfBirth >= data.joiningDateTime) {
    //   errors.joiningDateTime = "Joining date shouldn't be less than or equal to the Date of birth";
    // }
    // if (validator.isEmpty(data.designation)) {
    //   errors.designation = 'Designation type cannot be empty';
    // }
    // if (validator.isEmpty(data.department)) {
    //   errors.department = 'Department type cannot be empty';
    // }
    // if (validator.isEmpty(data.totalExperience)) {
    //   errors.totalExperience = 'Total experience cannot be empty';
    // }
    return errors;
  };

  const { data, errors, loading } = stateVal;
  const isDisabled = data?.admissionId;
  const winHeight = window.innerHeight;
  const thisData = (
    <Box
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'auto',
      }}>
      <Container>
        <Card>
          <form onSubmit={handleSubmit}>
            <ModalHeader>ADMISSION FORM</ModalHeader>
            <ModalBody>
              {errors.global && <div className="mt-10 ml-15 mr-15 pad-12 alert alert-danger">{errors.global}</div>}
              <div className="content">
                <div className="container-fluid">
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="">
                          Current batch<sup> *</sup>
                        </Label>
                        <Input value={data?.batchName || null} disabled={isDisabled} />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="">
                          Course<sup> *</sup>
                        </Label>
                        <Input
                          value={data.courseName || null}
                          onChange={e => handleSelectChange('courseId', e?.value)}
                          disabled={isDisabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="">
                          Application number<sup> *</sup>
                        </Label>
                        <Input
                          type="text"
                          name="applicationNo"
                          onChange={e => handleChange(e)}
                          value={data.applicationNo}
                          placeholder="Enter here..."
                          maxLength="50"
                          disabled={isDisabled}
                        />
                        {errors.applicationNo && <span className="err-msg">{errors.applicationNo}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">
                          Student Firstname<sup> *</sup>
                        </Label>
                        <Input
                          type="text"
                          name="firstName"
                          onChange={e => handleChange(e)}
                          value={data.firstName}
                          placeholder="Enter here..."
                          maxLength="50"
                          disabled
                        />
                        {errors.firstName && <span className="err-msg">{errors.firstName}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">
                          Student Lastname<sup> *</sup>
                        </Label>
                        <Input
                          type="text"
                          name="lastName"
                          onChange={e => handleChange(e)}
                          value={data.lastName}
                          placeholder="Enter here..."
                          maxLength="50"
                          disabled
                        />
                        {errors.lastName && <span className="err-msg">{errors.lastName}</span>}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="">
                          Guardian Email<sup> *</sup>
                        </Label>
                        <Input
                          type="text"
                          name="guardianEmail"
                          onChange={e => handleChange(e)}
                          value={data.guardianEmail}
                          placeholder="Enter here..."
                          maxLength="50"
                          disabled={isDisabled}
                        />
                        {errors.guardianEmail && <span className="err-msg">{errors.guardianEmail}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">
                          Guardian Phone<sup> *</sup>
                        </Label>
                        <Input
                          type="text"
                          name="phoneNumber"
                          onChange={e => handleChange(e)}
                          value={data.phoneNumber}
                          placeholder="Enter here..."
                          maxLength="50"
                          disabled={isDisabled}
                        />
                        {errors.phoneNumber && <span className="err-msg">{errors.phoneNumber}</span>}
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup style={{ marginTop: 15, marginBottom: 20 }}>
                        <Label for="exampleCheckbox">
                          Student Gender <sup>*</sup>
                        </Label>
                        <Row>
                          <Col sm={3}>
                            <CustomCheckbox
                              value={data.gender}
                              id="MALE"
                              name="gender"
                              label="Male"
                              onChange={handleCheckChange}
                              checked={data.gender === 'MALE'}
                            />
                          </Col>
                          <Col sm={3}>
                            <CustomCheckbox
                              value={data.gender}
                              id="FEMALE"
                              name="gender"
                              label="Female"
                              onChange={handleCheckChange}
                              checked={data.gender === 'FEMALE'}
                            />
                          </Col>
                        </Row>
                        {errors.gender && <span className="err-msg">{errors.gender}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Academic year</Label>
                        <Input
                          type="text"
                          name="acadYear"
                          onChange={e => handleChange(e)}
                          value={data.acadYear}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Admission year</Label>
                        <Input
                          type="text"
                          name="admissionYear"
                          onChange={e => handleChange(e)}
                          value={data.admissionYear}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>

                      <FormGroup className="customDatePickerWidth">
                        <Label htmlFor="">
                          Student Date of Birth<sup> *</sup>
                        </Label>
                        <br />
                        <DatePicker
                          className="form-control"
                          selected={data.dateOfBirth ? new Date(data.dateOfBirth) : null}
                          onChange={value => handleDateChange('dateOfBirth', value)}
                          dateFormat="dd/MM/yyyy"
                          showMonthDropdown
                          showYearDropdown
                          placeholderText="Select date..."
                          dropdownMode="select"
                        />
                        {errors.dateOfBirth && <span className="err-msg">{errors.dateOfBirth}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Birth place</Label>
                        <Input
                          type="text"
                          name="birthPlace"
                          onChange={e => handleChange(e)}
                          value={data.birthPlace}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Blood group</Label>
                        <Input
                          type="text"
                          name="bloodGroup"
                          onChange={e => handleChange(e)}
                          value={data.bloodGroup}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Mothertongue</Label>
                        <Input
                          type="text"
                          name="motherTongue"
                          onChange={e => handleChange(e)}
                          value={data.motherTongue}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Nationality</Label>
                        <Input
                          type="text"
                          name="nationality"
                          onChange={e => handleChange(e)}
                          value={data.nationality}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Student Religion</Label>
                        <Input
                          type="text"
                          name="religion"
                          onChange={e => handleChange(e)}
                          value={data.religion}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label for="exampleCheckbox">Student Physically challenged?</Label>
                        <Row>
                          <Col sm={3}>
                            <CustomCheckbox
                              id={`${true}`}
                              name="isPhysicallyChallenged"
                              label="Yes"
                              onChange={handleCheckChange}
                              checked={`${data.isPhysicallyChallenged}` === `${true}`}
                            />
                          </Col>
                          <Col sm={3}>
                            <CustomCheckbox
                              id={`${false}`}
                              name="isPhysicallyChallenged"
                              label="No"
                              onChange={handleCheckChange}
                              checked={`${data.isPhysicallyChallenged}` === `${false}`}
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label htmlFor="">Guardian Relation type</Label>
                        <Select
                          value={relationTypes?.find(el => el.value === data.relation) || null}
                          onChange={e => handleSelectChange('relation', e?.value)}
                          options={relationTypes}
                          isDisabled={true}
                        />
                        {errors.relation && <span className="err-msg">{errors.relation}</span>}
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Guardian Education</Label>
                        <Input
                          type="text"
                          name="education"
                          onChange={e => handleChange(e)}
                          value={data.education}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Guardian Income</Label>
                        <Input
                          type="text"
                          name="income"
                          onChange={e => handleChange(e)}
                          value={data.income}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Guardian Occupation</Label>
                        <Input
                          type="text"
                          name="occupation"
                          onChange={e => handleChange(e)}
                          value={data.occupation}
                          placeholder="Enter here..."
                          maxLength="50"
                        />
                      </FormGroup>

                      <FormGroup>
                        <Label for="exampleCheckbox">Staff child?</Label>
                        <Row>
                          <Col sm={3}>
                            <CustomCheckbox
                              id={`${true}`}
                              name="isStaffChild"
                              label="Yes"
                              onChange={handleCheckChange}
                              checked={`${data.isStaffChild}` === `${true}`}
                            />
                          </Col>
                          <Col sm={3}>
                            <CustomCheckbox
                              id={`${false}`}
                              name="isStaffChild"
                              label="No"
                              onChange={handleCheckChange}
                              checked={`${data.isStaffChild}` === `${false}`}
                            />
                          </Col>
                        </Row>
                      </FormGroup>
                      <FormGroup>
                        <Label htmlFor="">Status</Label>
                        <Select
                          value={statusList?.find(el => el.value === data.status) || null}
                          onChange={e => handleSelectChange('status', e?.value)}
                          options={statusList}
                          isDisabled={!loggedUserRole || loggedUserRole !== constants.roles.admin}
                        />
                        {errors.status && <span className="err-msg">{errors.status}</span>}
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <CustomButton
                type="submit"
                style={{ fontWeight: 'bold' }}
                variant="contained"
                color="secondary"
                disabled={loading}
                loading={loading}
                name="Submit"
              />
            </ModalFooter>
          </form>
        </Card>
      </Container>
    </Box>
  );
  return <div style={{ height: winHeight - 10 }}>{thisData}</div>;
};

export default UserAdmissionForm;
